<img #backward [src]="image" class="position-absolute" (click)="onClickEvent()" [ngStyle]="{
    'top.px': box.top,
    'width.px': box.width,
    'height.px': box.height,
    'left.px': box.left
  }" 
 />
